

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { MerchantAccountsContext } from '../../context/merchantAccounts/MerchantAccountContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';




export const MerchantAccountPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isUpdate, setIsUpdate] = useState(false);
    const { addMerchantAccount, updateMerchantAccount, accountTypes, banks, currencies } = useContext(MerchantAccountsContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');

    var merchantAccount;
    var merchant = state.merchant;

    if (state && state.merchantAccount != undefined) {


        merchantAccount = state.merchantAccount;

    } else {
        merchantAccount = {
            currencyId: 188,
            ibanAccount: '',
            bankCode: '',
            countryId: 1,
            accountTypeId: '1',
            accountName: ''
        }
    }

    useEffect(() => {
        if (state && state.merchantAccount != undefined) {
            setIsUpdate(true);
        }
    }, []);




    const { formState, onInputChange } = useForm(merchantAccount);

    const {
        countryId,
        currencyId,
        bankCode,
        accountTypeId,
        ibanAccount,
        accountName } = formState


    useEffect(() => {
        const bankCode = ibanAccount.substring(5, 8);
        onInputChange({ target: { name: 'bankCode', value: bankCode } });
    }, [ibanAccount]);

    const handleSave = async () => {

        const formValid = countryId > 0 && currencyId > 0 && bankCode > 0 && accountTypeId > 0 && ibanAccount.length > 0
            && accountName.length > 0;
        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos");
            return false;
        }

        var resp = "";
        formState.merchantId = merchant.id;

        if (isUpdate) {
            resp = await updateMerchantAccount(formState);
        } else {
            resp = await addMerchantAccount(formState);
        }
        if (resp == "success") {
            setSuccessMessage(isUpdate ? "Cuenta actualizada correctamente" : "Cuenta creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{isUpdate ? 'Actualizar cuenta' : 'Agregar cuenta'}</h3>
                <hr />

                <form className="row g-3 " >


                    <div className="mb-3">
                        <label htmlFor="currencySelect" className="form-label">Moneda *</label>
                        <select id='currencySelect' className={`form-select${required.mark(!(currencyId > 0))}`} name='currencyId' value={currencyId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {currencies.length > 0
                                ?
                                currencies.map(currency => (
                                    <option key={currency.code} value={currency.code} selected={currency.code == currencyId}>{currency.description}</option>
                                ))
                                :
                                <option selected>No hay monedas disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="IBANAccountInput" className="form-label">Cuenta IBAN *</label>
                        <input
                            id='IBANAccountInput'
                            type="text"
                            className={`form-control${required.mark(!ibanAccount)}`}
                            placeholder="Cuenta IBAN"
                            name="ibanAccount"
                            value={ibanAccount}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="accountNameInput" className="form-label">Nombre *</label>
                        <input
                            id='accountNameInput'
                            type="text"
                            className={`form-control${required.mark(!accountName)}`}
                            placeholder="Nombre"
                            name="accountName"
                            value={accountName}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3" >
                        <label htmlFor="bankSelect" className="form-label">Banco</label>
                        <select id='bankSelect' className="form-select" name='bankCode' value={bankCode} onChange={onInputChange} disabled>
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {banks.length > 0
                                ?
                                banks.map(bank => (
                                    <option key={bank.code} value={bank.code} selected={bank.code == bankCode}>{bank.description}</option>
                                ))
                                :
                                <option selected>No hay bancos disponibles</option>
                            }
                        </select>
                    </div>


                    <div className="mb-3">
                        <label htmlFor="accountTypeSelect" className="form-label">Tipo de cuenta *</label>
                        <select id='accountTypeSelect' className={`form-select${required.mark(!(accountTypeId > 0))}`} name='accountTypeId' value={accountTypeId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {accountTypes.length > 0
                                ?
                                accountTypes.map(accountType => (
                                    <option key={accountType.code} value={accountType.code} selected={accountType.code == accountTypeId}>{accountType.description}</option>
                                ))
                                :
                                <option selected>No hay bancos disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>






                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
